















































































































































































































































































































































































































































































































































































































































































import { Component, Mixins, Watch } from 'vue-property-decorator'
import VueRouter from 'vue-router'
import GlobalMixin, { ALERT_TYPE, VIEW_MODE } from '@/mixins/globalMixin'
import LoadingComponent from '@/components/LoadingComponent.vue'
import AlertBarComponent from '@/components/AlertBarComponent.vue'
import BreadcrumbsComponent from '@/components/BreadcrumbsComponent.vue'
import DatePickerComponent from '@/components/DatePickerComponent.vue'
import AgencySelectDialogComponent from '@/components/AgencySelectDialogComponent.vue'
import PdfViewComponent from '@/components/PdfViewComponent.vue'
import SendMailDialogComponent from '@/components/SendMailDialogComponent.vue'
import { Product } from '@/domain/Product'
import { Invoice, MailQueue } from '@/domain/Invoice'
import { AgencyInfo } from '@/domain/AgencyInfo'
import { User } from '@/domain/User'
import { SendMail } from '@/domain/SendMail'
import InvoicesService from '@/service/InvoicesService'
import NumberIssuingService from '@/service/NumberIssuingService'
import ZipService from '@/service/ZipService'

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
])

@Component({
  components: {
    LoadingComponent,
    AlertBarComponent,
    BreadcrumbsComponent,
    DatePickerComponent,
    AgencySelectDialogComponent,
    PdfViewComponent,
    SendMailDialogComponent,
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      const invoicesService = InvoicesService.instance
      if (to.params["no"] === undefined) {
        /* 新規 */
        vm.$data.viewMode = VIEW_MODE.NEW
        if (typeof to.query["refs"] === "string") {
          const requestNos = to.query["refs"].split(",")
          invoicesService.referenceNew(requestNos).then(x => vm.$data.dto = x)
        } else {
          invoicesService.createNew().then(x => vm.$data.dto = x)
        }
      } else {
        /* 編集 */
        vm.$data.viewMode = VIEW_MODE.VIEW
        invoicesService.edit(to.params["no"]).then(x => vm.$data.dto = x)
      }
    })
  },
})
export default class MemberInvoiceEdit extends Mixins(GlobalMixin) {
  numberIssuingService = NumberIssuingService.instance
  zipService = ZipService.instance

  dto = new Invoice()
  originalDto = this.dto.clone()
  products: Product[] = []
  productLoadCount = 0
  sendMail = new SendMail()
  isViewReportFileSendMode = false

  /* 支払期限リスト */
  maturities = [
          "請求書発行日翌月末迄に銀行振込でお願い致します。",
          "前払いで銀行振込をお願い致します。",
  ]

  /* 敬称リスト */
  honorifics = [
          "御中",
          "様",
  ]


  /* 作成者、承認者リスト */
  users: User[] = []
  authorityUsers: User[] = []

  mounted () {
    this.usersService.findByOccupationCode(1)
      .then((x) => {
        this.users = x
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.log(error)
        this.users = []
      })
    this.usersService.findByAuthorityCode(4)
      .then((x) => {
        this.authorityUsers = x
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.log(error)
        this.authorityUsers = []
      })
  }

  /**
   * 画面を遷移する前のチェック
   */
  // eslint-disable-next-line
  beforeRouteLeave(to: VueRouter, from: VueRouter, next: any) {
    if (!this.isView) {
      this.confirm("このページから移動しますか？入力中のデータは保存されません").then(res => {
        res === true ? next() : next(false)
      })
    } else {
      next()
    }
  }
  
  /**
   * 編集モードに切り替える
   */
  onEdit() {
    if (this.dto.isPrinted || this.dto.isMailSended) {
      this.confirm("既に印刷またはメール送信していますが、本当に編集してよろしいですか？").then(res => {
        if (res === true) {
          this.viewMode = VIEW_MODE.EDIT
        }
      })
    } else {
      this.viewMode = VIEW_MODE.EDIT
    }
    this.originalDto = this.dto.clone()
  }

  /**
   * 削除
   */
  onDelete() {
    this.confirm("本当に削除してよろしいですか？").then(res => {
      if (res === true) {
        this.showLoading()
        this.invoicesService.delete(this.dto.invoiceNo)
          .then(() => {
            this.viewMode = VIEW_MODE.DELETED
            this.alert("削除しました", ALERT_TYPE.SUCCESS)
            this.hideLoading()
          })
          .catch((error) => {
            // eslint-disable-next-line
            console.log(error)
            this.alert("削除に失敗しました", ALERT_TYPE.ERROR)
            this.hideLoading()
          })
      }
    })
  }

  /**
   * 編集取消
   */
  onReset() {
    this.confirm("本当に編集を取り消してよろしいですか？").then(res => {
      if (res === true) {
        this.dto = this.originalDto
        this.viewMode =  VIEW_MODE.VIEW
      }
    })
  }



  /**
   * 登録ボタンのクリック
   */
  onSubmit(event: Event) {
    if ((this.$refs.observer as Vue & { validate: () => boolean }).validate()) {
      if (this.viewMode === VIEW_MODE.NEW) {
          this.invoicesService.createchk(this.dto)
             .then(status => {
               this.alert(String(status), ALERT_TYPE.ERROR)
               if (status > 0) {
                 this.alert("請求済みのデータが含まれています", ALERT_TYPE.ERROR)
                  event.stopPropagation()
               } else {
                  /* 登録 */
                  this.numberIssuingService.next(NumberIssuingService.INVOICE, this.dto.invoiceOn)
                    .then(no => {
                      this.dto.invoiceNo = no
                      this.save()
                    })
                    .catch(error => {
                      // eslint-disable-next-line
                      console.log(error)
                    })
                }
              })
      } else {
        /* 更新 */
        if (this.dto.isPrinted || this.dto.isMailSended) {
          this.confirm("印刷およびメール送信情報は、消去されますがよろしいですか？").then(res => {
            if (res === true) {
              this.save()
            } else {
              event.stopPropagation()
            }
          })
        } else {
          this.save()
        }
      }
    } else {
      event.stopPropagation()
    }
  }

  onBrSubmit(event: Event) {
    if ((this.$refs.observer as Vue & { validate: () => boolean }).validate()) {
      if (this.viewMode === VIEW_MODE.NEW) {
        event.stopPropagation()
      } else {
        /* 更新 */
        if (this.dto.isPrinted || this.dto.isMailSended) {
          this.confirm("枝番発行します(必要に応じ備考に記載ください)。印刷およびメール送信情報は、消去されますがよろしいですか？").then(res => {
            if (res === true) {
              this.brSave()
            } else {
              event.stopPropagation()
            }
          })
        } else {
          this.confirm("枝番発行します。よろしいですか？").then(res => {
            if (res === true) {
              this.brSave()
            } else {
              event.stopPropagation()
            }
          })
        }
      }
    } else {
      event.stopPropagation()
    }
  }



  /**
   * 明細行を追加
   */
  addDetailLine() {
    this.dto.addDetailLine()
  }

  /**
   * 明細行を削除
   */
  deleteDetailLine(lineIndex: number) {
    this.confirm("明細行を削除してよろしいですか？").then(res => {
      if (res === true) {
        this.dto.deleteDeailLine(lineIndex)
      }
    })
  }

  /**
   * 商品の変更
   */
  onChangeLineItem(lineIndex: number, event: Product) {
    const line = this.dto.details[lineIndex]
    line.inspectionInfo.inspectionCode = event.pk.inspectionCode
    line.inspectionInfo.inspectionName = event.inspectionName
    line.inspectionInfo.inspectionShortName = event.inspectionShortName
    line.inspectionInfo.classificationCode = event.classificationCode
    line.inspectionInfo.otherItem = event.otherItem
    line.inspectionInfo.days = event.days
    line.priceInfo.unitPrice = event.unitPrice
    line.priceInfo.taxRate = this.getTaxRate()
  }

  /**
   * 作成者の変更
   */
  onChangeAuthor(event: User) {
    this.dto.authorUser.userId = event.userId
    this.dto.authorUser.userName = event.userName
  }

  /**
   * 承認者の変更
   */
  onChangeAuthorizer(event: User) {
    this.dto.authorizerUser.userId = event.userId
    this.dto.authorizerUser.userName = event.userName
  }

  /**
   * オートコンプリートフィルター
   */
  // eslint-disable-next-line
  usersFilter(item: User, queryText: string, itemText: string) {
    return item.userName.toLowerCase().indexOf(queryText.toLowerCase()) >= 0
  }

  /**
   * 商品オートコンプリートフィルター
   */
  // eslint-disable-next-line
  productsFilter(item: Product, queryText: string, itemText: string) {
    return item.inspectionName.toLowerCase().indexOf(queryText.toLowerCase()) >= 0
  }

  /**
   * 印刷ボタンのクリック
   */
  onPrint() {
    this.invoicesService.print(this.dto.invoiceNo)
      .then(dto => {
        this.dto = dto
        this.openPdfViewDialog("請求書印刷", dto.invoiceFile.content)
      })
  }

  /**
   * メール送信ボタンのクリック
   */
  onSendMail() {
    this.isViewReportFileSendMode = this.dto.hasAgency || this.dto.customerInfo.billingRule !== 2
    this.invoicesService.generateMailTemplate([this.dto.invoiceNo])
      .then(x => {
        this.sendMail = x
        this.mailSendDialog = true
      })
      .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
          this.alert("メール送信テンプレートの取得に失敗しました", ALERT_TYPE.ERROR)
          this.hideLoading()
      })
  }

  /**
   * データの保存
   */
  private save() {
    this.showLoading()
    this.pdfService.generateInvoice(this.dto)
      .then(pdf => {
        this.dto.invoiceFile = pdf
        this.dto.printAt = null
        this.dto.mailSendAt = null

        if (this.isNew) {
          this.invoicesService.create(this.dto)
            .then((x) => {
              this.dto = x
              this.viewMode = VIEW_MODE.VIEW
              this.alert("保存しました", ALERT_TYPE.SUCCESS)
              this.hideLoading()
            })
            .catch((error) => {
              // eslint-disable-next-line
              console.log(error)
              this.alert("保存に失敗しました", ALERT_TYPE.ERROR)
              this.hideLoading()
            })
        } else {
          this.invoicesService.update(this.dto)
            .then((x) => {
              this.dto = x
              this.viewMode = VIEW_MODE.VIEW
              this.alert("保存しました", ALERT_TYPE.SUCCESS)
              this.hideLoading()
            })
            .catch((error) => {
              // eslint-disable-next-line
              console.log(error)
              this.alert("保存に失敗しました", ALERT_TYPE.ERROR)
              this.hideLoading()
            })
        }
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.log(error)
        this.alert("保存に失敗しました", ALERT_TYPE.ERROR)
        this.hideLoading()
      })
  }


  /**
   * データの保存(枝番)
   */
  private brSave() {
    this.showLoading()
    this.dto.invoiceBrNo+=1
    this.pdfService.generateInvoice(this.dto)
      .then(pdf => {
        this.dto.invoiceFile = pdf
        this.dto.printAt = null
        this.dto.mailSendAt = null

        if (this.isNew) {
					//あり得ない
        } else {
          this.invoicesService.brUpdate(this.dto)
            .then((x) => {
              this.dto = x
              this.viewMode = VIEW_MODE.VIEW
              this.alert("枝番　保存しました", ALERT_TYPE.SUCCESS)
              this.hideLoading()
            })
            .catch((error) => {
              // eslint-disable-next-line
              console.log(error)
              this.alert("保存に失敗しました", ALERT_TYPE.ERROR)
              this.hideLoading()
            })
        }
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.log(error)
        this.alert("保存に失敗しました", ALERT_TYPE.ERROR)
        this.hideLoading()
      })
  }




  /**
   * 初期化処理
   */
  @Watch("dto")
  changeDto() {
    /* 初期化処理 */
    if (this.viewMode === VIEW_MODE.NEW) {
      /* 作成者 */
      const authorUser = this.users.find(x => x.userId === this.loginUserId)
      if (authorUser !== undefined) {
        this.dto.authorUser.userId = authorUser.userId
        this.dto.authorUser.userName = authorUser.userName
      }
    }
  }

  /**
   * 請求日変更時
   */
  @Watch("dto.invoiceOn")
  changeInvoiceOn() {
    this.taxWash()
  }

  /**
   * 顧客変更時に商品マスタの再読み込み
   */
  @Watch("dto.customerInfo")
  chengeCustomer() {
    this.loadProducts()
  }

  /**
   * 代理店変更時に商品マスタの再読み込み
   */
  @Watch("dto.agencyInfo")
  chengeAgency() {
    this.loadProducts()
  }

  /**
   * 郵便番号変更
   */
  @Watch("dto.invoiceToInfo.invoiceToZipCode")
  changeZipCode() {
    const pattern = /^\d{3}-?\d{4}$/g
    if (!this.dto.invoiceToInfo.invoiceToZipCode.match(pattern) || this.dto.invoiceToInfo.invoiceToAddress1 !== "") return

    this.zipService.getAddress(this.dto.invoiceToInfo.invoiceToZipCode)
      .then(x => {
        this.dto.invoiceToInfo.invoiceToAddress1 = x
      })
  }

  /**
   * 消費税率の取得
   */
  private getTaxRate() {
    /* 輸入検査の場合、免税 */
    return this.dto.requestType === 1 ? 0 : this.taxsService.findByActiveTax(this.dto.invoiceOn)
  }

  /**
   * 消費税率の洗い替え
   */
  private taxWash() {
    const taxRate = this.getTaxRate()
    this.dto.details.forEach(x => x.priceInfo.taxRate = taxRate)
  }

  /**
   * 商品マスタの再読み込み
   */
  private loadProducts() {
    const isAgency = this.dto.agencyInfo.agencyPrefectureCode !== null && this.dto.agencyInfo.agencyPrefectureCode !== ""
    const prefectureCode = isAgency ? this.dto.agencyInfo.agencyPrefectureCode : this.dto.customerInfo.customerPrefectureCode
    const customerCode = isAgency ? this.dto.agencyInfo.agencyCode : this.dto.customerInfo.customerCode

    if (prefectureCode !== null && prefectureCode !== "" && customerCode !== null && customerCode !== "") {
      this.productsService.findByCustomer(prefectureCode, customerCode)
          .then(x => {
            this.products = x
            if (!this.isView && this.productLoadCount > 2) {  // 最初の２回は洗い替えしない(初期表示時にロードされる)
              /* 既存の明細の単価を洗い替え */
              this.dto.details.forEach(detail => {
                const product = this.products.find(p => p.pk.inspectionCode === detail.inspectionInfo.inspectionCode)
                if (product !== undefined) {
                    detail.priceInfo.unitPrice = product.unitPrice
                }
              })
            }
          })
    }
  }

  /**
   * 代理店選択ダイアログの表示
   */
  openAgencySelectDialog() {
    if (!this.isView) {
      this.agencySelectDialog = true
    }
  }

  /**
   * 代理店選択クリア
   */
  clearAgency() {
    this.dto.agencyInfo = new AgencyInfo()
  }

  /**
   * 代理店変更
   */
  changeAgency() {
    if (this.dto.agencyInfo.agencyName === null) {
      this.clearAgency()
    }
  }

  /**
   * 代理店選択
   */
  onAgencySelected(event: AgencyInfo) {
    this.dto.agencyInfo = event
  }

  /**
   * メール送信
   */
  onSendMailed(event: SendMail) {
    this.showLoading()
    const mailQueue = new MailQueue({to: event.to, cc: event.cc, bcc: event.bcc, replyTo: event.replyTo, subject: event.subject, content: event.content, invoiceNos: [this.dto.invoiceNo], reportFileSendMode: event.reportFileSendMode, reportNos: event.reportNos})
    this.invoicesService.mailQueuePush(mailQueue)
      .then((x) => {
          this.dto.mailSendAt = x.mailSendAt
          this.alert("メール送信しました", ALERT_TYPE.SUCCESS)
          this.hideLoading()
      })
      .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
          this.alert("メール送信に失敗しました", ALERT_TYPE.ERROR)
          this.hideLoading()
      })
  }

  /**
   * 編集
   */
  private edit(invoiceNo: string) {
    /* 編集 */
    this.showLoading()
    this.invoicesService.edit(invoiceNo)
      .then(x => {
        this.viewMode = VIEW_MODE.VIEW
        this.$router.push(`/member/invoice/edit/${x.invoiceNo}`)
        this.dto = x
        this.hideLoading()
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.log(error)
        this.alert("データ取得エラー", ALERT_TYPE.ERROR)
        this.hideLoading()
      })
  }
}
